import api from "@/services/api";

export interface CreateSimplePartnerPayload {
  name: string;
  phone: string;
  email: string;
  document: string;
  franchiseId?: string;
  useAssociateTax?: boolean;
  usePartnerPremiumVoucher?: boolean;
}

class CreateSimplePartner {
  execute = async (payload: CreateSimplePartnerPayload) => {
    const response = await api().post("/partner/simple", payload);
    return response.data;
  };
}

export { CreateSimplePartner };



